import type {ReactElement} from 'react';
import {FontControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-control/font-control';
import type {DescriptionFontControlProps} from './description-font-control.types';

export function DescriptionFontControl({component}: DescriptionFontControlProps): ReactElement {
  return <FontControl component={component} />;
}